<a (click)="backToSearchResults()" tabindex="0">
  <i class="far fa-arrow-alt-circle-left" aria-hidden="true"></i>
  Back to search results
</a>
@if (apiStatus$ | async; as status) {
  <h2>Contract #: {{ contractNumber }} details</h2>
  @if (status === responseStatus.error500) {
    <div>
      <ent-alert-message type="error">{{ message.applicationDown }}</ent-alert-message>
    </div>
  }
  @if (status === responseStatus.error401) {
    <div>
      <ent-alert-message type="error">{{ message.unAuthorizedError }}</ent-alert-message>
    </div>
  }
  @if (status === responseStatus.success) {
    <section>
      <!-- case / reg60 tracker -->
      @if (contractTrackerData && contractTrackerData.length > 0) {
        <app-tracker-tabs
          [noLOA]="noLOA"
          [notNoLOA]="notNoLOA"
          [contractTrackerData]="contractTrackerData"
          [contractData]="contractData"
          [reg60TrackerData]="reg60TrackerData"
          [mobileView]="mobileView">
        </app-tracker-tabs>
      }
      <!-- client information -->
      @if (clientInfoTableConfig.data && clientInfoTableConfig.data.length > 0) {
        <app-client-information>
          <ent-primary-table [tableData]="clientInfoTableConfig"></ent-primary-table>
        </app-client-information>
      }
      <!-- requirements -->
      <app-requirement [requirementData]="requirementsData" id="outstanding-requirements"></app-requirement>
      <!-- agent information -->
      @if (agentInfoTableConfig.data && agentInfoTableConfig.data.length > 0 ) {
        <app-agent-information [agentData]="agentData" aria-live="polite">
          @if (agentInfoTableConfig.data.length > 3) {
            <ent-primary-table [tableData]="agentInfoTableConfig"></ent-primary-table>
            @if (agentInfoTableConfig.config.rowsPerPage !== agentInfoTableConfig.data.length) {
              <a id="viewall"
                href="javascript:void(0)" (click)="viewAllrows()" aria-expanded="false">
                View all {{ agentInfoTableConfig.data.length }}
                <i class="fas fa-caret-down" aria-hidden="true"></i>
              </a>
            }
            @if (agentInfoTableConfig.config.rowsPerPage === agentInfoTableConfig.data.length) {
              <a id="viewless"
                href="javascript:void(0)" (click)="viewLessrows()" aria-expanded="true">
                View less
                <i class="fas fa-caret-up" aria-hidden="true"></i>
              </a>
            }
          }
        </app-agent-information>
      }
      <!-- contract and rate lock information-->
      <div class="contract-and-rate-lock-info">
        <app-contract-information>
          <ent-primary-table [tableData]="contractInfoTableConfig"></ent-primary-table>
        </app-contract-information>
        @if (rateLockInfo.effectiveDate) {
          <app-rate-lock-information [rateLockInfo]="rateLockInfo">
          </app-rate-lock-information>
        }
      </div>
      <!-- source of fund -->
      @if (sourceOfFundsTableConfig.data && sourceOfFundsTableConfig.data.length > 0) {
        <app-source-of-fund id="source-of-fund">
          <ent-primary-table [tableData]="sourceOfFundsTableConfig"></ent-primary-table>
        </app-source-of-fund>
      }
      <!-- fund received -->
      @if (fundsReceivedTableConfig.data && fundsReceivedTableConfig.data.length > 0) {
        <app-fund-received id="funds-received">
          <ent-primary-table [tableData]="fundsReceivedTableConfig"></ent-primary-table>
        </app-fund-received>
      }
    </section>
  }
}

